"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isReferenceResolver = isReferenceResolver;
exports.makeReferenceResolver = makeReferenceResolver;
exports.ReferenceResolver = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _AllStrategy = require("./strategy/AllStrategy");

var _IdStrategy = require("./strategy/IdStrategy");

var _SearchStrategy = require("./strategy/SearchStrategy");

var _invariant = _interopRequireDefault(require("react-utils/invariant"));

var _isObject = _interopRequireDefault(require("transmute/isObject"));

var _isString = _interopRequireDefault(require("transmute/isString"));

var ReferenceResolver =
/*#__PURE__*/
function () {
  function ReferenceResolver(definition, name) {
    (0, _classCallCheck2.default)(this, ReferenceResolver);
    (0, _invariant.default)((0, _isObject.default)(definition), 'expected `definition` to be an Object but got `%s`', definition);
    (0, _invariant.default)((0, _isString.default)(name), 'expected `name` to be a string but got `%s`', name);
    this._name = name;
    var all = definition.all,
        byId = definition.byId,
        search = definition.search;
    this.all = all && (0, _AllStrategy.makeAllResolver)(all);
    this.byId = byId && (0, _IdStrategy.makeIdResolver)(byId);
    this.search = search && (0, _SearchStrategy.makeSearchResolver)(search);

    this.getDefinition = function () {
      return definition;
    };
  }

  (0, _createClass2.default)(ReferenceResolver, [{
    key: "toString",
    value: function toString() {
      return this._name + "<" + Object.keys(this.getDefinition()).join(',') + ">";
    }
  }]);
  return ReferenceResolver;
}();

exports.ReferenceResolver = ReferenceResolver;

function isReferenceResolver(thing) {
  return thing instanceof ReferenceResolver;
}

function makeReferenceResolver(definition) {
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ReferenceResolver';
  return new ReferenceResolver(definition, name);
}